import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-564e441e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "groupbuy_boxs" }
const _hoisted_2 = { id: "box_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        id: "groupbuy_box",
        key: `groupbuy_box_${index}`
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.des, (des, k) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "box_des",
            key: `box_des_${k}`
          }, _toDisplayString(des), 1))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rules, (rule, j) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "box_rule",
            key: `box_rule_${j}`
          }, _toDisplayString(rule), 1))
        }), 128))
      ]))
    }), 128))
  ]))
}